// Isr MFE's that need previous navigation history
// eslint-disable-next-line import/prefer-default-export
export const ISR_MFE = [
    'investor_details',
];
